<template>
  <div>
    <SelectList
      v-model="serviceLevel"
      clearable
      dense
      emit-value
      label="Select Service Level"
      :options="serviceLevelOptions"
      :readonly="readonly"
    />
  </div>
</template>

<script>
import { organisationServiceLevels } from "shared/constants";

import SelectList from "src/components/common/SelectList.vue";

export default {
  name: "OrganisationServiceLevelSelector",
  components: {
    SelectList,
  },
  props: {
    modelValue: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
    },
    region: {
      type: String,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  computed: {
    serviceLevel: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    serviceLevelOptions() {
      return organisationServiceLevels.filter((serviceLevel) =>
        serviceLevel.region.includes(this.region)
      );
    },
  },
};
</script>
